import styled from '@emotion/styled';
import { Variables } from '@enter/core';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    box-sizing: border-box;
    padding: 8px 22px 22px;
`;

export const Note = styled.p`
    margin: 0;
    font-family: ${Variables.Fonts.calibre};
    font-size: 13px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMild};
`;

export const Status = styled.p`
    margin: 0;
    font-family: ${Variables.Fonts.calibre};
    font-size: 14px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMedium};
`;

export const ErrorText = styled.p`
    margin: 0;
    font-family: ${Variables.Fonts.calibre};
    font-size: 14px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.AttentionInverted3};
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

export const FailureList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 240px;
    overflow: auto;
`;

export const FailureItem = styled.li`
    padding: 8px 10px;
    border-radius: 6px;
    border: 1px solid ${Variables.ThemeLight.Border1};
    background: ${Variables.ThemeLight.Background1};
    color: ${Variables.ThemeLight.TextMedium};
    font-family: ${Variables.Fonts.calibre};
    font-size: 13px;
    line-height: 1.4;
`;
